import { TideClientConfig } from "..";

import {
  PackagingTransaction,
  PackagingAccommodationRequest,
  PackagingAccommodationResponse,
  PackagingEntry,
  BookingPriceDetails,
  ClientPortalItinerary,
  FlightSearchRequest,
  PackagingFlightResponse,
  BookingPackageDossier,
} from "../types";
import { PackagingRequestBase } from "../types/booking-v2/request/packaging/packaging-request-base";
import { get, post } from "./common-client";

const ENDPOINT = "/api/web/packaging";
const ENDPOINT_START_TRANSACTION = `${ENDPOINT}/start`;
const ENDPOINT_ACCOMMODATIONS = `${ENDPOINT}/accommodations`;
const ENDPOINT_EXCURSIONS = `${ENDPOINT}/excursions`;
const ENDPOINT_FLIGHTS = `${ENDPOINT}/flights`;
const ENDPOINT_PRICE_DETAILS = `${ENDPOINT}/price-details`;
const ENDPOINT_BOOK = `${ENDPOINT}/book`;
const ENDPOINT_ITINERARY = `${ENDPOINT}/itinerary`;
const ENDPOINT_ENTRY = (magicLinkCode: string) =>
  `${ENDPOINT}/entry/${magicLinkCode}`;

export const startTransaction = (
  config: TideClientConfig,
  signal?: AbortSignal
): Promise<PackagingTransaction> => {
  const apiKey = config.apiKey;
  const url = `${config.host}${ENDPOINT_START_TRANSACTION}`;
  return get(url, apiKey, config.token, signal, true);
};

export const searchPackagingAccommodations = (
  config: TideClientConfig,
  request: PackagingAccommodationRequest,
  signal?: AbortSignal
): Promise<PackagingAccommodationResponse[]> => {
  const url = `${config.host}${ENDPOINT_ACCOMMODATIONS}`;
  const apiKey = config.apiKey;
  const body = JSON.stringify(request);

  return post(url, apiKey, body, config.token, signal, true);
};

export const searchPackagingFlights = (
  config: TideClientConfig,
  request: FlightSearchRequest,
  signal?: AbortSignal
): Promise<PackagingFlightResponse[]> => {
  const url = `${config.host}${ENDPOINT_FLIGHTS}`;
  const apiKey = config.apiKey;
  const body = JSON.stringify(request);

  return post(url, apiKey, body, config.token, signal, true);
};

export const searchPackagingExcursions = (
  config: TideClientConfig,
  request: PackagingAccommodationRequest,
  signal?: AbortSignal
): Promise<PackagingAccommodationResponse[]> => {
  const url = `${config.host}${ENDPOINT_EXCURSIONS}`;
  const apiKey = config.apiKey;
  const body = JSON.stringify(request);

  return post(url, apiKey, body, config.token, signal, true);
};

export const getEntry = (
  config: TideClientConfig,
  magicLinkCode: string,
  signal?: AbortSignal
): Promise<PackagingEntry> => {
  const apiKey = config.apiKey;

  const url = `${config.host}${ENDPOINT_ENTRY(magicLinkCode)}`;

  return get(url, apiKey, config.token, signal, true);
};

export const getPriceDetails = (
  config: TideClientConfig,
  request: PackagingRequestBase<PackagingEntry>,
  signal?: AbortSignal
): Promise<BookingPriceDetails> => {
  const url = `${config.host}${ENDPOINT_PRICE_DETAILS}`;
  const apiKey = config.apiKey;
  const body = JSON.stringify(request);

  return post(url, apiKey, body, config.token, signal, true);
};

export const getItinerary = (
  config: TideClientConfig,
  request: PackagingRequestBase<PackagingEntry>,
  signal?: AbortSignal
): Promise<ClientPortalItinerary> => {
  const url = `${config.host}${ENDPOINT_ITINERARY}`;
  const apiKey = config.apiKey;
  const body = JSON.stringify(request);

  return post(url, apiKey, body, config.token, signal, true);
};

export const bookPackagingEntry = (
  config: TideClientConfig,
  request: PackagingRequestBase<PackagingEntry>,
  signal?: AbortSignal
): Promise<BookingPackageDossier> => {
  const url = `${config.host}${ENDPOINT_BOOK}`;
  const apiKey = config.apiKey;
  const body = JSON.stringify(request);

  return post(url, apiKey, body, config.token, signal, true);
};
